import { app } from "modular-openscriptjs";
import { tab } from "../../../helpers";

const h = app("h");

export default function SuggestedUsersCanvas(...args) {
	return h._(
		h.div(
			{
				class: "border-0 offcanvas offcanvas-bottom rounded-top-5 shadow-lg",
				tabindex: "-1",
				style: `min-height: 50vh; max-height: 85vh;`,
				data_bs_scroll: "true",
			},
			// Handle/Grip
			h.div(
				{ class: "w-100 d-flex justify-content-center pt-3 pb-1" },
				h.div({
					class: "bg-secondary opacity-25 rounded-pill",
					style: "width: 40px; height: 4px;",
				})
			),
			h.button({
				class: "d-none",
				mo_canvas_dismiss_btn: `feed-canvas`,
				data_bs_dismiss: "offcanvas",
			}),
			h.div(
				{ class: "fs-5 fw-bold p-2 text-center text-dark" },
				h.span({}, "Who to Follow")
			),
			h.div(
				{ class: "offcanvas-body px-0" },
				h.Tabs({
					holders: {
						nav: h.div({
							class: "bg-light justify-content-center mb-4 mx-auto nav nav-pills rounded-pill p-1 shadow-sm sticky-top",
							style: "max-width: fit-content; top: 0; z-index: 10;",
						}),
						body: h.div({ class: "tab-content px-3" }),
					},
					reversed: true,
					tabs: [
						tab(
							h.button(
								{
									class: "nav-link rounded-pill px-4 fw-500 active",
									data_bs_toggle: "pill",
								},
								"Users"
							),
							h.div(
								{ class: "tab-pane fade show active" },
								h.SuggestedUsers(
									{
										type: "users",
										filter: "similar",
										attributes: {
											class: "d-flex gap-3 flex-nowrap overflow-auto align-items-stretch p-1 pb-3 hide-scrollbar",
										},
									},
									{
										class: "d-flex gap-3 flex-nowrap overflow-auto align-items-stretch mb-3 p-1 pb-3 hide-scrollbar",
									}
								)
							)
						),
						tab(
							h.button(
								{
									class: "nav-link rounded-pill px-4 fw-500",
									data_bs_toggle: "pill",
								},
								"Businesses"
							),
							h.div(
								{ class: "tab-pane fade" },
								h.SuggestedUsers(
									{
										type: "businesses",
										filter: "similar",
										attributes: {
											class: "d-flex gap-3 flex-nowrap overflow-auto align-items-stretch p-1 pb-3 hide-scrollbar",
										},
									},
									{
										class: "d-flex gap-3 flex-nowrap overflow-auto align-items-stretch mb-3 p-1 pb-3 hide-scrollbar",
									}
								)
							)
						),
					],
				})
			),
			...args
		)
	);
}
